import { UIView } from "@uirouter/react";

import { translate } from "app/filters/i18nFilter";
import {
    COMPANY_ANALYSIS_ROOT,
    COMPANY_ANALYSIS_HOME,
    HOME_PAGE_ROUTE,
    SI_ROOT_ROUTE,
    COMPANY_ANALYSIS_PAGE_ROUTE_URL,
} from "app/pages/sales-intelligence/constants/routes";
import settingsService from "app/pages/sales-intelligence/modules/company-analysis/services/settings/settingsService";
import GatePage from "app/pages/sales-intelligence/pages/company-analysis/containers/gate-page/GatePageRoot/GatePageRoot";
import type { IRouterState } from "single-spa/react-app/router/IRouterState";

import { COMPANY_STATE_CONFIG } from "./company-states-config";
import { WEBSITE_STATE_CONFIG } from "./website-states-config";

export const COMPANY_ANALYSIS_CONFIG: Record<string, IRouterState> = {
    [COMPANY_ANALYSIS_ROOT]: {
        abstract: true,
        parent: SI_ROOT_ROUTE,
        url: COMPANY_ANALYSIS_PAGE_ROUTE_URL,
        get configId(): string {
            return settingsService.getComponentsConfigId();
        },
        component: UIView,
    },
    [COMPANY_ANALYSIS_HOME]: {
        stateId: COMPANY_ANALYSIS_HOME,
        reset: undefined,
        parent: COMPANY_ANALYSIS_ROOT,
        url: "/home",
        secondaryBarType: "None",
        get pageTitle() {
            return translate("si.account-overview.company.document.title");
        },
        homeState: HOME_PAGE_ROUTE,
        pageId: {
            section: "account-overview",
            subSection: "home",
            subSubSection: undefined,
        },
        trackingId: {
            section: "Account Review",
            subSection: "analysis home",
            subSubSection: "analysis gate",
        },
        component: GatePage,
    },
    ...COMPANY_STATE_CONFIG,
    ...WEBSITE_STATE_CONFIG,
};
